import React, { useEffect } from "react";
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectSignIn } from "../../store/slices/signed-in-slice";
import { deleteTokens } from "./Delete-Tokens";


// refresh token gets cleared from server and access token gets cleared, as well as everything else in local storage
export const SignOut = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isSignedIn = useSelector(selectSignIn);

    // If user is signed out ,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn === false) {
            navigate("/signin");
        }
    }, [dispatch, isSignedIn, navigate]);

    return (
        <>  
            {/* <ToastContainer location="top-center"/> */}
            <Button onClick={() => deleteTokens()}>Sign Out</Button>
        </>
    );
};